import { TableAction, TableDataSchema } from '@brasshq/ui-kit';
import { EmptyScreenProps } from 'src/sharedComponents/EmptyScreen';
import { HandlePermission, TFunc } from 'src/types';

import { TeamMatesTableState } from '../types';

import * as sentInvitesTableConfig from './sentInvitesTableConfig';
import * as teamMembersTableConfig from './teamMembersTableConfig';

type Config = {
  actions?: TableAction[];
  dataSchema: TableDataSchema[];
  emptyStateProps: EmptyScreenProps | null;
};

type ConfigActions = {
  handleStateUpdate: TFunc<Partial<TeamMatesTableState>>;
  handlePermissions: HandlePermission;
};

export function getTeamMatesTableConfig(
  activeTabIndex: number,
  actions: ConfigActions,
): Config {
  const config: Config = {
    actions: [],
    dataSchema: [],
    emptyStateProps: null,
  };
  switch (activeTabIndex) {
    case 0:
      return {
        ...config,
        actions: teamMembersTableConfig.createActions(
          actions.handleStateUpdate,
          actions.handlePermissions,
        ),
        dataSchema: teamMembersTableConfig.createDataSchema(),
      };
    case 1:
      return {
        ...config,
        dataSchema: sentInvitesTableConfig.createDataSchema(),
        actions: sentInvitesTableConfig.createActions(
          actions.handleStateUpdate,
          actions.handlePermissions,
        ),
        emptyStateProps: sentInvitesTableConfig.createEmptyState(),
      };
    default:
      return config;
  }
}
